class LaCompleteSet extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    const limit = this.dataset.limit || 4;
    if (!productId) return;

    const base = this.dataset.url || '/recommendations/products';
    const url = `${base}?product_id=${productId}&section_id=la-complete-set&limit=${limit}`;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        this._load(url);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    observer.observe(this);
  }

  _load(url) {
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector('product-recommendations');
        if (!source || !source.innerHTML.trim()) return;

        // Use a <template> so the full subtree is inert (no custom-element
        // upgrades) until it's appended to the live document. Once appended,
        // all children are already in the DOM before any constructor runs,
        // so modal-opener / quick-add-modal can safely querySelector children.
        const tmpl = document.createElement('template');
        tmpl.innerHTML = source.innerHTML;
        this.appendChild(tmpl.content);
      })
      .catch(() => {});
  }
}

if (!customElements.get('la-complete-set')) {
  customElements.define('la-complete-set', LaCompleteSet);
}
